import { Box, MenuItem, SelectChangeEvent } from '@mui/material';
import FieldLabel from '../../common/FieldLabel';
import SweepSelect from '../../common/SweepSelect';
import {
  NestedFieldsField,
  NestedFieldsSelector,
} from '../../common/fieldsSelectors/NestedFieldsSelector';
import { useSweepFieldsInfo } from '../../../sweep-fields/useSweepFieldsInfo';
import { colors } from '@sweep-io/sweep-design';
import { parseSweepFieldPolymorphicID } from '../../common/fieldsSelectors/nestedFieldsSelectorHelper';
import { TeamsRecipientType } from '../teams/types';
import { SweepField, SfdcDisplayType } from '../../../types/fields';

interface TeamsSelectDealroomTypeProps {
  crmOrgId: string;
  objectName: string;
  value: SweepCreatedTeamsChannel | SalesforceCreatedTeamsChannel;
  onChange: (value: SweepCreatedTeamsChannel | SalesforceCreatedTeamsChannel) => any;
  readonly?: boolean;
}

export const TeamsSelectDealroomType = ({
  crmOrgId,
  objectName,
  readonly,
  value,
  onChange,
}: TeamsSelectDealroomTypeProps) => {
  const { getEnrichedNestedPath } = useSweepFieldsInfo();
  const filterByEndSelectionText = (field: SweepField) => {
    const { isResolvable } = parseSweepFieldPolymorphicID(field.id || '');
    if (isResolvable) {
      return true;
    }
    if (field.sfDisplayType === SfdcDisplayType.STRING) {
      return true;
    }
    return false;
  };

  return (
    <Box sx={{ mb: '20px' }}>
      <FieldLabel label={'Choose deal room'} />
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <SweepSelect
          menuMaxHeight="320px"
          FormControlProps={{
            sx: { minWidth: '296px', marginRight: '8px', mt: '3px' },
          }}
          SelectProps={{
            disabled: readonly,
            value: value?.type ?? '',
            onChange: (event: SelectChangeEvent<unknown>) => {
              const val = event.target.value as any;
              onChange({ type: val });
            },
          }}
        >
          {[
            TeamsRecipientType.CHANNEL_STORED_IN_SWEEP,
            TeamsRecipientType.CHANNEL_STORED_IN_SALESFORCE_FIELD,
          ].map((type) => (
            <MenuItem key={type} value={type}>
              {type === TeamsRecipientType.CHANNEL_STORED_IN_SWEEP
                ? "Record's deal room"
                : "Related record's deal room"}
            </MenuItem>
          ))}
        </SweepSelect>
        {value?.type === TeamsRecipientType.CHANNEL_STORED_IN_SALESFORCE_FIELD && (
          <Box
            sx={{
              border: `1px solid ${colors.grey[300]}`,
              borderRadius: '4px',
              background: colors.white,
              maxWidth: '500px',
              minWidth: '296px',
            }}
          >
            <NestedFieldsSelector
              placeholder="Choose field"
              readonly={readonly}
              crmOrgId={crmOrgId}
              objectType={objectName}
              filterBy={filterByEndSelectionText}
              nestedPath={getEnrichedNestedPath(value?.value?.fieldIds)}
              onChange={(sweepField: NestedFieldsField) => {
                onChange({
                  type: TeamsRecipientType.CHANNEL_STORED_IN_SALESFORCE_FIELD,
                  value: { fieldIds: sweepField.fieldIds },
                });
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
